import { API_URL, API_VERSION } from '@constants';
import { useData } from '@hooks/useData';
import { paths } from '../../types/api';
import { ApiError, useApiConfig } from '@hooks/useApiConfig';

const ENDPOINT_URL = '/prd-products/my-account';

const ENDPOINT_URL_WITH_VERSION = `${API_VERSION}${ENDPOINT_URL}` as const;
type url = typeof ENDPOINT_URL_WITH_VERSION;

export type GetMyAccountProductsInput = paths[url]['get']['parameters']['query'];
export type GetMyAccountProductsSuccessResponse = paths[url]['get']['responses']['200']['content']['application/json'];

/**
 * Requests endpoint to get paginated user's products.
 */
export const useGetMyAccountProducts = () => {
    const { getHeaders, getCommonParameters, handleCommonErrors } = useApiConfig();
    const { setMyAccountProducts, setIsLoadingMyAccountProducts } = useData();

    const request = async (props: GetMyAccountProductsInput) => {
        setIsLoadingMyAccountProducts(true);

        const propsString = JSON.stringify({ ...props });

        try {
            const inputParameters = new URLSearchParams({ ...getCommonParameters(), ...JSON.parse(propsString) }).toString();

            const response = await fetch(`${API_URL}${ENDPOINT_URL}?${inputParameters}`, {
                method: 'GET',
                headers: getHeaders(),
            });

            if (!response.ok) {
                const error = new Error() as ApiError;

                try {
                    const json = await response.json();
                    error.message = json.message;
                    error.errors = json.errors;
                } catch (error: any) {
                    error.message = '';
                }
                
                error.statusCode = response.status;
                
                throw error;
            }

            const data: GetMyAccountProductsSuccessResponse = await response.json();

            setMyAccountProducts(data);
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error: any) {
            handleCommonErrors(error);
        } finally {
            setIsLoadingMyAccountProducts(false);
        }
    };

    return { request };
};
